import React from "react";
import Tooltip from "@material-ui/core/Tooltip";
import IconButton from "@material-ui/core/IconButton";
import StateIcon from "../../../../utils/render_test_status";

import {BasicTestResultForLlmRun} from "common/flowmaster/types/test";

type Props = {
  result: BasicTestResultForLlmRun;
  link?: string;
  onClick?: () => void;
};

export default function TestResultComponent({result, link, onClick}: Props) {
  const handleButtonClick = () => {
    window.open(link, "_blank");
  };
  const statsMessage =
    "stats" in result ? createStatsMessage(result.stats) : undefined;
  return (
    <Tooltip
      title={statsMessage ?? getMessage(result) ?? undefined}
      arrow={true}
      PopperProps={{style: {zIndex: 100000}}}
    >
      <IconButton
        size="small"
        onClick={link !== undefined ? handleButtonClick : onClick}
      >
        <StateIcon state={result.state} />
      </IconButton>
    </Tooltip>
  );
}

function getMessage(
  result: BasicTestResultForLlmRun,
): NonNullable<React.ReactNode> {
  return "detail" in result &&
    typeof result.detail === "object" &&
    result.detail !== null &&
    "message" in result.detail
    ? (result.detail?.message as string)
    : "";
}

function createStatsMessage(stats) {
  return `Pass: ${stats.pass}, Fail: ${stats.fail}${
    stats.pending ? `, Pending: ${stats.pending}` : ""
  }`;
}
